import { useSelector } from 'react-redux'
import props from '../../../../../redux/props'
import { NAWSurvey } from '../../../../../types/NAW/Survey'
import { Update } from '../../../../hooks/NAW/useNAWSurveyAnswer/useNAWSurveyAnswer'
import RangeWithLabelAndDescription from '../../Elements/RangeWithLabelAndDescription'
import HeadlineSplit from '../HeadlineSplit'
import { getRecommendedDeskSharingQuote, getMitarbeiter, getTables } from './calculation'
import { formatNumber } from '../../../../../utility'
import { useEffect } from 'react'

type Props = {
  survey: NAWSurvey
  update: Update
}

const DeskSharingAndSummary: React.FC<Props> = ({ survey, update }) => {
  const t = useSelector((s) => s[props.TRANSLATION])

  const getQuote = () => {
    return formatNumber(survey.deskSharingPercentage)
  }

  const getEmployees = () => {
    return getMitarbeiter(survey)
  }

  useEffect(() => {
    if (!survey.deskSharingPercentage) {
      update('deskSharingPercentage')(getRecommendedDeskSharingQuote(survey))
    }
  }, [survey, update])

  return (
    <div className="flex flex-col gap-5 md:gap-10 relative h-full">
      <div className="hidden md:block">
        <HeadlineSplit
          suffix={t.naw.survey.answer.summary.deskSharingAndSummary.suffix}
          subline={t.naw.survey.answer.summary.deskSharingAndSummary.subline}
        />
      </div>
      <div className="md:hidden">
        <HeadlineSplit suffix={t.naw.survey.answer.summary.deskSharingAndSummary.suffix} />
      </div>
      <div className="flex flex-col gap-3 md:gap-5">
        <div className="flex gap-1">
          <div className="text-black font-bold md:text-lg">
            {t.naw.survey.answer.summary.deskSharingAndSummary.slider.label(formatNumber(getRecommendedDeskSharingQuote(survey)))}
          </div>
        </div>
        <div className="whitespace-pre-line ">
          <span className="text-black">{t.naw.survey.answer.summary.deskSharingAndSummary.text.tillQuote}</span>
          <span className="text-black">{formatNumber(getRecommendedDeskSharingQuote(survey))}</span>
          <span className="text-black">{t.naw.survey.answer.summary.deskSharingAndSummary.text.tillTables}</span>
          <span className="text-black">
            {getTables(survey, getRecommendedDeskSharingQuote(survey))}&nbsp;{t.naw.survey.answer.summary.deskSharingAndSummary.text.tableSuffix}
          </span>
          <span className="text-black">{t.naw.survey.answer.summary.deskSharingAndSummary.text.fromTables}</span>
          <span className="text-black">{`${getEmployees()}${t.naw.survey.answer.summary.deskSharingAndSummary.text.employeesSuffix}`}</span>
          <span className="text-black">{t.naw.survey.answer.summary.deskSharingAndSummary.text.fromEmployees}</span>
        </div>
        <div className="text-black font-bold md:text-lg mt-5">{t.naw.survey.answer.summary.deskSharingAndSummary.individualize}</div>
        <RangeWithLabelAndDescription
          hidePercentage
          value={survey.deskSharingPercentage}
          onChange={update('deskSharingPercentage')}
          {...t.naw.survey.configuration.deskSharingPercentage}
          small
          marker={[getRecommendedDeskSharingQuote(survey)]}
        />
        <div className="whitespace-pre-line">
          <span className="text-black">{t.naw.survey.answer.summary.deskSharingAndSummary.textInvidivual.tillQuote}</span>
          <span>
            <strong className="text-black">{getQuote()}</strong>
          </span>
          <span className="text-black">{t.naw.survey.answer.summary.deskSharingAndSummary.textInvidivual.tillTables}</span>
          <span className="text-black">
            {getTables(survey)}&nbsp;{t.naw.survey.answer.summary.deskSharingAndSummary.textInvidivual.tableSuffix}
          </span>
          <span className="text-black">{t.naw.survey.answer.summary.deskSharingAndSummary.textInvidivual.fromTables}</span>
          <span className="text-black">{`${getEmployees()}${t.naw.survey.answer.summary.deskSharingAndSummary.textInvidivual.employeesSuffix}`}</span>
        </div>
      </div>
    </div>
  )
}

export default DeskSharingAndSummary
